import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsComponent {
    public isOpen = false;

    public toggleContact() {
        this.isOpen = !this.isOpen;
    }
}
